import AppStoreOptimizationIcon from "@assets/images/mobile-app-development/app-store-optimization-icon.avif";
import MobileAppPrototypingIcon from "@assets/images/mobile-app-development/mobile-app-prototyping-icon.avif";
import PerformanceAndAppSizeOptimizationIcon from "@assets/images/mobile-app-development/performance-and-app-size-optimization-icon.avif";
import QualityAssuranceAndTestingIcon from "@assets/images/mobile-app-development/quality-assurance-and-testing-icon.avif";
import SecurityAndComplianceIcon from "@assets/images/mobile-app-development/security-and-compliance-icon.avif";
import ServerManagementAndScalingIcon from "@assets/images/mobile-app-development/server-management-and-scaling-icon.avif";
import SystemArchitectureDesignIcon from "@assets/images/mobile-app-development/system-architecture-design-icon.avif";


export const coreFeatures = [
    {
        heading: 'Third-party API Integrations',
        text: " Third-party API integrations connect an application to external services and data sources, extending its capabilities. This also allows for the seamless inclusion of essential functions like payment processing, mapping, social logins, and more."
    },
    {
        heading:'Modern Connectivity (5G & Bluetooth LE)',
        text:" Modern connectivity standards like 5G and Bluetooth Low Energy (BLE) are essential for high-performance applications. They provide the high-speed, low-latency, and energy-efficient communication required for advanced mobile and IoT solutions."
    },
    {
        heading:'E-commerce and Payment Gateway Integration',
        text:" E-commerce functionality allows for direct sales and transactions within an application, creating a seamless digital storefront. Secure payment gateway integration is a critical component that enables safe and reliable processing of all customer payments."
    },{
        heading:'Push Notifications',
        text:" Push notifications serve as a direct communication channel to engage and retain users, even when the app is closed. They are used to deliver timely alerts, personalized marketing messages, and important updates to enhance the user experience."
    },{
        heading:'Offline Functionality Implementation',
        text:" Offline functionality is a crucial feature that allows an app to remain useful without an active internet connection. It enables uninterrupted access by storing data locally and synchronizing it with the server once connectivity is restored."
    },{
        heading:' App Monetization',
        text:" App monetization refers to the strategy of generating revenue from an application. Common models include in-app purchases, recurring subscriptions, and the integration of advertising services to create sustainable income streams."
    },
     {
        heading:'AI/ML Integrations',
        text:'Artificial Intelligence (AI) and Machine Learning (ML) integrations transform an application by enabling intelligent, data-driven features. This allows for capabilities like predictive analytics, automations, voice commands, quick-response customer support chatbots, and security features like biometric authentication and fraud detection.'
    },
    {
        heading:'AR/VR Integrations',
        text:"Augmented Reality (AR) and Virtual Reality (VR) are technologies that create deeply immersive user experiences. AR overlays digital information onto the real world, while VR creates fully simulated environments, opening new possibilities for interaction and engagement."
    },
   
]

export const technicalExpertise =[
    
    {
        heading:'Security and Compliance',
        text:" Application security involves implementing robust measures to protect the software and its user data from threats and vulnerabilities. Our compliance processes ensure the application adheres to legal and industry, data protection standards such as GDPR or HIPAA, and financial transaction protection standards such as PCI DSS.",
        img:SecurityAndComplianceIcon
    },
    {
        heading:'System Architecture Design',
        text:" A robust system architecture serves as the foundational blueprint for a digital product, ensuring it is scalable, secure, and maintainable. Our strategic planning dictates the application's performance and ability to grow, preventing future bottlenecks and technical debt.",
        img:SystemArchitectureDesignIcon
    },
     {
        heading:'UI/UX and Prototyping',
        text:"UI/UX design is the practice of creating an intuitive, engaging, and accessible user journey, from visual appeal to overall usability. Prototyping brings our designs to life for early testing, validating concepts to ensure the final product is both beautiful and effortless to navigate.",
        img:MobileAppPrototypingIcon
    }
    ,{
        heading:'Server Management and Scaling',
        text:" Our effective server management ensures the backend infrastructure supporting an application is reliable, secure, and always available. Through scaling we enable our cloud infrastructure to dynamically handle increases in user traffic and data load without a loss in performance.",
        img:ServerManagementAndScalingIcon
    },
     
    {
        heading:'App Store Optimization (ASO)',
        text:"App Store Optimization is the process of improving an app's visibility within the Apple App Store and Google Play Store. We aim to increase organic downloads by optimizing keywords, visuals, and product descriptions to rank higher in search results.",
        img:AppStoreOptimizationIcon
    },
   {
        heading:'Performance & App Size Optimization',
        text:" Performance optimization is the process of making an application fast, responsive, and efficient in its use of device resources. Our app size optimization focuses on minimizing the application's download size, which directly improves download completion rates.",
        img:PerformanceAndAppSizeOptimizationIcon
    },
    
   
    {
        heading:'Quality assurance and testing',
        text:" Quality Assurance (QA) is a systematic process that ensures a digital product meets the highest standards before its release. Our rigorous testing methodologies discover and resolve bugs, ensuring the final product is stable, functional, reliable and adhering to the highest quality standards.",
        img:QualityAssuranceAndTestingIcon
    },
]